import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Main } from "./Main.jsx";
import { RegisterConfirm } from "./RegisterConfirm.jsx";
import { RecoverPasswordConfirm } from "./RecoverPasswordConfirm.jsx";
import { Offer } from "./Offer.jsx";
import { DonateTab } from "./components/tabs/DonateTab.jsx";
import { MainTab } from "./components/tabs/MainTab.jsx";
import { Rules } from "./Rules.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Main page={MainTab} donateButton={{text: "Донатный магазин", href: "/donate"}} />} />
        <Route exact path="/donate" element={<Main page={DonateTab} donateButton={{text: "Главная страница", href: "/"}} />} />
        <Route exact path="/offer" element={<Offer />} />
        <Route exact path="/rules" element={<Rules />} />
        <Route path="/register_confirm" element={<RegisterConfirm />} />
        <Route path="/recover_password_confirm" element={<RecoverPasswordConfirm />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
